/**
 * Help videos in a pop-up (snippets/btf-help-video.liquid), in the manner of the Enlarge dialog.
 *
 *   <div data-btf-hv data-btf-hv-title="Made in my town">
 *     <button type="button" data-btf-hv-open>Watch how it works</button>
 *     <template data-btf-hv-wide><video …></template>
 *     <template data-btf-hv-phone><video …></template>
 *   </div>
 *
 * - A screen taller than it is wide (a phone, a tablet held upright) gets the 9:16 film, any
 *   other the 16:9 one; where only one is given it is used everywhere.
 * - The video is copied out of its template only when the button is pressed, so the page pays
 *   nothing for it until then, and it starts with sound because the press is the go-ahead.
 * - Escape, the cross or a click on the backdrop closes it; the video is removed (so it stops
 *   downloading) and focus goes back to the button. The page underneath is left as it was.
 */

let dialog = null;
let opener = null;

function build() {
  const d = document.createElement('dialog');
  d.className = 'btf-hv-dialog';
  d.innerHTML =
    '<div class="btf-hv-dialog__bar"><span class="btf-hv-dialog__title"></span>' +
    '<button type="button" class="btf-hv-dialog__x" aria-label="Close the video">' +
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 4l16 16M20 4L4 20" fill="none" stroke="currentColor" stroke-width="2.5"/></svg></button></div>' +
    '<div class="btf-hv-dialog__view"></div>';
  d.addEventListener('click', (e) => {
    if (e.target === d || e.target.classList.contains('btf-hv-dialog__view') || e.target.closest('.btf-hv-dialog__x')) d.close();
  });
  d.addEventListener('close', () => {
    const video = d.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach((s) => s.remove());
      video.load();
    }
    d.querySelector('.btf-hv-dialog__view').replaceChildren();
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  });
  document.body.append(d);
  return d;
}

function open(box, from) {
  const upright = window.innerHeight > window.innerWidth;
  const tpl =
    (upright && box.querySelector('template[data-btf-hv-phone]')) ||
    box.querySelector('template[data-btf-hv-wide]') ||
    box.querySelector('template[data-btf-hv-phone]');
  if (!tpl) return;
  if (!dialog) dialog = build();

  const video = tpl.content.querySelector('video').cloneNode(true);
  video.removeAttribute('id');
  video.playsInline = true;
  video.controls = true;
  const w = Number(video.getAttribute('width')) || (tpl.hasAttribute('data-btf-hv-phone') ? 9 : 16);
  const h = Number(video.getAttribute('height')) || (tpl.hasAttribute('data-btf-hv-phone') ? 16 : 9);
  dialog.style.setProperty('--btf-hv-ratio', String(w / h));

  const title = box.dataset.btfHvTitle || '';
  dialog.querySelector('.btf-hv-dialog__title').textContent = title ? 'How it works · ' + title : 'How it works';
  dialog.setAttribute('aria-label', title ? 'How it works: ' + title : 'How it works');
  dialog.querySelector('.btf-hv-dialog__view').replaceChildren(video);

  opener = from;
  dialog.showModal();
  dialog.querySelector('.btf-hv-dialog__x').focus({ preventScroll: true });

  const go = video.play();
  // A browser that still refuses sound starts it muted rather than not at all
  if (go && go.catch) {
    go.catch(() => {
      video.muted = true;
      video.play().catch(() => {});
    });
  }
}

document.addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null;
  const btn = t && t.closest('[data-btf-hv-open]');
  if (!btn) return;
  // A Help page card names its video box by id; the box may sit inside a hidden wrapper
  const named = btn.dataset.btfHvOpen && document.getElementById(btn.dataset.btfHvOpen);
  const box = btn.closest('[data-btf-hv]') || (named && (named.matches('[data-btf-hv]') ? named : named.querySelector('[data-btf-hv]')));
  if (!box) return;
  e.preventDefault();
  open(box, btn);
});
